import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./Articles.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import {useCommonContext} from "../../contexts/CommonContext";
import ButtonType from "../../ui_components/Button/ButtonType";
import NewArticleButton from "../../shared_components/Buttons/NewArticleButton/NewArticleButton";
import ArticleStore from './ArticleStore';
import ArticleRow from './ArticleRow/ArticleRow';
import ShowArticleCostsButton from '../../shared_components/Buttons/ShowArticleCostsButton/ShowArticleCostsButton';
import ArticleCategorySelect from '../../shared_components/Selects/ArticleCategorySelect/ArticleCategorySelect';
import ArticleCategory from '../../entities/productOrder/article/ArticleCategory';
import TransferArticleButton from '../../shared_components/Buttons/TransferArticleButton/TransferArticleButton';


const Articles: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const store = new ArticleStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        store.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store]);

    const onUpdate = async () => {
        await store.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    const onCategoryChange = (newCategory?: ArticleCategory) => {
        store.categoryFilter = newCategory;
    }

    const clearFilter = async () => {
        await store.clearFilter()
    }

    return (
        <Observer>
            {() => (
                <div className={classes.articles_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        
                        <div>
                            <TransferArticleButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                            <ShowArticleCostsButton type={ButtonType.SECONDARY}/>
                        </div>
                        <NewArticleButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <div className={classes.filter_items_container}>
                            <FilterInput value={store.filter}
                                placeholder={i18n.translate("ARTICLE_FILTER_PLACEHOLDER")}
                                onChange={(value) => {
                                    store.setFilter(value)
                                }} onEnter={() => store.search()}/>
                            <ArticleCategorySelect
                                selected={store.categoryFilter}
                                fullWidth onChange={onCategoryChange}/>
                        </div>
                        <div className={classes.filter_buttons_container}>
                            <Button
                                onClick={() => {
                                    store.search()
                                }}
                                className={classes.search_btn}
                                type={ButtonType.PRIMARY}
                                text={i18n.translate("SEARCH")}
                            />
                            <Button
                                onClick={clearFilter}
                                className={classes.search_btn}
                                text={i18n.translate("CLEAN")}
                            />
                        </div>
                    </Box>
                    {!store.isEmpty &&
                    <div className={classes.articles_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={i18n.translate("ARTICLES")}
                                        pagination={store.pagination}/>
                        <div className={classes.elements_container}>
                            {store.articles.map((article, i) => (
                                <ArticleRow
                                    onUpdate={onUpdate}
                                    article={article} key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={i18n.translate("ARTICLES")}
                            pagination={store.pagination}/>
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={FastfoodIcon} title={i18n.translate("NO_ARTICLES_TITLE")}
                                 subtitle={i18n.translate("NO_ARTICLES_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default Articles;
